export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7597.bb32bbc7.jpg";